module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIwMSIgdmlld0JveD0iMCAwIDMwMSAyMDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjREEyNTFEIiBkPSJNLjUuNWgzMDB2MjAwSC41eiIvPjxwYXRoIGZpbGw9IiNGRjAiIGQ9Ik0xMDIuMTY4IDgzLjgxNWwyNi40ODEgMTkuMjQtMTAuMTE1IDMxLjEzMSAyNi40ODItMTkuMjM5IDI2LjQ4MSAxOS4yMzktMTAuMTE1LTMxLjEzMSAyNi40ODItMTkuMjRoLTMyLjg0MWwtMTAuMDA3LTMwLjc5OC0xMC4wMDcgMzAuNzk4eiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-vn.svg
// module id = A8ra
// module chunks = 2